exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/pem1hfh.css);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);", ""]);

// module
exports.push([module.id, ".Error {\r\n  margin: 0 auto;\r\n  position: relative;\r\n  overflow-y: auto;\r\n  background-color: #3485be;\r\n  text-align: center;\r\n  color: #ffffff;\r\n  height: 100%; }\r\n  .Error .container {\r\n    width: 80%;\r\n    margin: 50% auto 0; }\r\n    .Error .container .closeButton {\r\n      font-weight: bold;\r\n      font-size: 14px;\r\n      width: 30px;\r\n      height: 30px;\r\n      border: none;\r\n      padding: 5px;\r\n      border-radius: 5px;\r\n      cursor: pointer;\r\n      background-color: #3485be;\r\n      position: fixed;\r\n      font-size: 36px;\r\n      right: 5px;\r\n      top: 5px;\r\n      z-index: 999; }\r\n      .Error .container .closeButton:hover {\r\n        color: rgba(255, 255, 255, 0.8); }\r\n      .Error .container .closeButton:focus, .Error .container .closeButton:active {\r\n        color: rgba(255, 255, 255, 0.4); }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/Error/Error.css
// module id = 1020
// module chunks = 0